module.exports = __webpack_public_path__ + "img/mortgagePromo-tablet.46811b9e.jpg";